














import { Component, Prop, Vue } from 'vue-property-decorator';
import { CategoryDto } from '@eurogast/hub-client-typescript';
import { namespace } from 'vuex-class';
import { CART } from '@/store/types';

const cart = namespace(CART);

@Component({
})
export default class AutoCompleteCategoryLinks extends Vue {
  @Prop({required: false, default: () => []})
  public categories: CategoryDto[];

  @Prop({required: true})
  public browseUrl: string;

  public getCategoryUrl(cat: CategoryDto): string {
    return `${this.browseUrl}/${cat.id.replace(/\|/g, '-')}/${cat.name}`;
  }
}
